import { Navigate } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom'
import { Clientes } from '../app/Clientes/screen';
import { Contatos } from '../app/Contatos/screen';
import { Dashboard } from '../app/Dashboard/screens';
import { NotasFiscais } from '../app/NotasFiscais/screen';
import { Produtos } from '../app/Produto/screen';
import { Usuarios } from '../app/Usuarios/screen';
import { MovimentosPage } from '../app/Movimento/screen';
import { PrivateRouter } from './PrivateRouter';
import { URLS } from './URLS';
import { ImprimirMovimento } from '../app/ImprimirMovimento';
import { Botijoes } from '../app/Botijao/screen';
import { Auditoria } from '../app/Auditoria/screen';

function Rotas() {
  return (
    <Routes>
      <Route path={URLS.DASHBOARD} element={
        <PrivateRouter>
          <Dashboard />
        </PrivateRouter>
      }/>
      <Route path={URLS.PRODUTOS} element={
        <PrivateRouter>
          <Produtos />
        </PrivateRouter>
      }/>
      <Route path={URLS.BOTIJAO} element={
        <PrivateRouter>
          <Botijoes />
        </PrivateRouter>
      }/>
      <Route path={URLS.CLIENTES} element={
        <PrivateRouter>
          <Clientes />
        </PrivateRouter>
      }/>
      <Route path={URLS.USUARIOS} element={
        <PrivateRouter>
          <Usuarios />
        </PrivateRouter>
      }/>
      <Route path={URLS.CONTATOS} element={
        <PrivateRouter>
          <Contatos />
        </PrivateRouter>
      }/>
      <Route path={URLS.NOTAS_FISCAIS} element={
        <PrivateRouter>
          <NotasFiscais />
        </PrivateRouter>
      }/>
      <Route path={URLS.MOVIMENTOS} element={
        <PrivateRouter>
          <MovimentosPage />
        </PrivateRouter>
      }/>
      <Route path={URLS.AUDITORIA} element={
        <PrivateRouter>
          <Auditoria />
        </PrivateRouter>
      }/>
      <Route path={URLS.MOVIMENTOS_IMPRESSAO} element={
        <PrivateRouter>
          <ImprimirMovimento />
        </PrivateRouter>
      }/>
      <Route path='*' element={<Navigate to='/' replace/>}/>
    </Routes>
  );
}

export default Rotas;
